// extracted by mini-css-extract-plugin
module.exports = {"card":"WhyChooseFixter_card__u2iKh","label":"WhyChooseFixter_label__AL5UU","ellipse":"WhyChooseFixter_ellipse__rhQ5z","arrow":"WhyChooseFixter_arrow__XViWX"};